import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-video-ballby-ball',
  templateUrl: './video-ballby-ball.component.html',
  styleUrls: ['./video-ballby-ball.component.scss'],
})
export class VideoBallbyBallComponent implements OnInit {
  title = 'app-video-ballby-ball';

  ngOnInit(): void {}
}
